module.exports = __webpack_public_path__ + "img/no-job-selected-ja.252a10e2.svg";